// extracted by mini-css-extract-plugin
export default {"outer_card":"card_outer_card__zRHL1","card_text":"card_card_text__9MGRe","card_quantity":"card_card_quantity__jUtmi","card_title":"card_card_title__F8R2D"};